module.exports = __webpack_public_path__ + "static/media/screenshot-2.dc7bd9f7.png";